var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import DRNText from '../../../standard/Text/DRNText';
import PropTypes from 'prop-types';
import { getTextStyle } from '../utils/getStyle';
import R from '../../../core-res/R';
class EventText extends Component {
    render() {
        const _a = this.props, { text, index, theme, activeEventIndex } = _a, rest = __rest(_a, ["text", "index", "theme", "activeEventIndex"]);
        const color = theme.borderSubtle;
        return (<DRNText {...rest} style={[styles.textStyle, { color }, getTextStyle(index, activeEventIndex)]}>
        {text}
      </DRNText>);
    }
}
EventText.propTypes = {
    text: PropTypes.string.isRequired,
    theme: PropTypes.object,
    index: PropTypes.number.isRequired,
    activeEventIndex: PropTypes.number.isRequired,
};
const styles = StyleSheet.create({
    textStyle: Object.assign({}, R.typography.uiBaseline, { marginLeft: R.spacing.s }),
});
export default EventText;
